"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnDetailsDialogQueryWrapper = void 0;
const tslib_1 = require("tslib");
const components_1 = require("@apollo/client/react/components");
const catalog_core_1 = require("@tableau/catalog-core");
const catalog_messages_1 = require("@tableau/catalog-messages");
const catalog_queries_1 = require("@tableau/catalog-queries");
const data_catalog_shared_1 = require("@tableau/data-catalog-shared");
const data_structures_1 = require("@tableau/data-structures");
const widgets_1 = require("@tableau/widgets");
const react_1 = tslib_1.__importDefault(require("react"));
const RemoteTypeIcon_1 = require("../datagrid/cellFormatters/RemoteTypeIcon");
const LabelsHookHelper_1 = require("../Labels/LabelsHookHelper");
const renderQueryResult_1 = require("../renderQueryResult");
const LinksDisplayGrid_1 = require("../sharedDisplayGrid/LinksDisplayGrid");
const ColumnAndFieldDetailsStyles_1 = require("../style/ColumnAndFieldDetailsStyles");
const ColumnActionsMenuHelper_1 = require("./ColumnActionsMenuHelper");
const ColumnDetailsActionsMenu_1 = require("./ColumnDetailsActionsMenu");
const ColumnFieldsQueryGrid_1 = require("./ColumnFieldsQueryGrid");
const ColumnFlowsQueryGrid_1 = require("./ColumnFlowsQueryGrid");
const ColumnInlineDescriptionEditor_1 = require("./ColumnInlineDescriptionEditor");
const ColumnInlineTagEditor_1 = require("./ColumnInlineTagEditor");
const dialogWidth = 600;
function ColumnDetailsDialog(_a) {
    var _b, _c, _d, _e;
    var { column } = _a, props = tslib_1.__rest(_a, ["column"]);
    const renderOnce = react_1.default.useRef(false);
    const { customSensitivityLabelsEnabled } = (0, catalog_core_1.useFeatureFlags)();
    const descriptionEditor = (0, ColumnInlineDescriptionEditor_1.useColumnInlineDescriptionEditor)({
        columnLuid: column.luid,
        columnTableLuid: extractTableLuid(column),
        description: column.description || '',
        afterDescriptionChange: props.afterDescriptionAndTagsChange,
        canEditDescription: props.canSetDescriptionAndTags,
    });
    const taggingEditor = (0, ColumnInlineTagEditor_1.useColumnInlineTagEditor)({
        columnLuid: column.luid,
        tags: (0, data_structures_1.removeNulls)(column.tags.map(tag => tag.name)),
        onUpdate: props.afterDescriptionAndTagsChange,
        canEditTags: props.canSetDescriptionAndTags,
        viewOnly: true,
    });
    const enterEditModeFromActionsMenu = react_1.default.useCallback((action) => {
        if (action && !renderOnce.current) {
            switch (action) {
                case ColumnActionsMenuHelper_1.ColumnActions.Description:
                    descriptionEditor.startEditing();
                    break;
                case ColumnActionsMenuHelper_1.ColumnActions.Tag:
                    taggingEditor.startEditing();
                    break;
                case ColumnActionsMenuHelper_1.ColumnActions.QualityWarning:
                case ColumnActionsMenuHelper_1.ColumnActions.SensitiveLabels:
                case ColumnActionsMenuHelper_1.ColumnActions.CustomLabels:
                    break;
            }
        }
        renderOnce.current = true;
    }, [renderOnce, descriptionEditor, taggingEditor]);
    react_1.default.useEffect(() => {
        enterEditModeFromActionsMenu(props.detailsAction);
    }, [enterEditModeFromActionsMenu, props.detailsAction]);
    const fieldsCount = (_c = (_b = column.referencedByFieldsConnection) === null || _b === void 0 ? void 0 : _b.totalCount) !== null && _c !== void 0 ? _c : null;
    const flowsCount = (_e = (_d = column.referencedByFlowColumnInputFieldConnection) === null || _d === void 0 ? void 0 : _d.totalCount) !== null && _e !== void 0 ? _e : null;
    return (react_1.default.createElement(widgets_1.DialogWidget, { testId: 'column-details', title: catalog_messages_1.Messages.ColumnDetails(), type: widgets_1.DialogType.NormalWithTitleBar, positioningBehavior: widgets_1.DialogPositioningBehavior.Centered, showCloseButton: true, showFooter: false, isModal: true, onCloseRequest: props.onClose, handleGlassClick: props.onClose, dialogWidth: dialogWidth },
        react_1.default.createElement(ColumnAndFieldDetailsStyles_1.ColumnDetailsPane, null,
            customSensitivityLabelsEnabled
                ? (react_1.default.createElement(ColumnAndFieldDetailsStyles_1.ActionMenuProperties, null,
                    react_1.default.createElement(ColumnDetailsActionsMenu_1.ColumnDetailsActionsMenu, { columnId: props.columnId, column: column, canUpdate: props.canSetDescriptionAndTags, enterDescriptionEdit: descriptionEditor.startEditing, enterTaggingEdit: taggingEditor.startEditing })))
                : null,
            react_1.default.createElement(ColumnAndFieldDetailsStyles_1.ColumnDetailsColumnName, null, column.name),
            react_1.default.createElement(ColumnAndFieldDetailsStyles_1.ColumnDetailsTypeRow, null,
                react_1.default.createElement(RemoteTypeIcon_1.RemoteTypeIcon, { remoteType: column.remoteType }),
                data_catalog_shared_1.RemoteTypeMappings[column.remoteType]()),
            react_1.default.createElement(LabelsHookHelper_1.LabelWrapper, { itemInfo: column, isEager: true, kind: 'chip', wrapper: (e) => react_1.default.createElement("span", { style: ColumnAndFieldDetailsStyles_1.columnAndFieldDetailsLabelsStyle }, e) }),
            react_1.default.createElement(ColumnAndFieldDetailsStyles_1.ColumnDetailsProperties, null,
                descriptionEditor.element,
                taggingEditor.element,
                react_1.default.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsProperty, null,
                    react_1.default.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsLabel, null, catalog_messages_1.Messages.UsedByFields()),
                    react_1.default.createElement(ColumnAndFieldDetailsStyles_1.ColumnFieldsWrapper, { style: { height: (0, LinksDisplayGrid_1.getRowHeight)(fieldsCount, ColumnAndFieldDetailsStyles_1.columnFieldsWrapperMaxRows) } },
                        react_1.default.createElement(ColumnFieldsQueryGrid_1.ColumnFieldsQueryGrid, { columnId: props.columnId, rowCount: fieldsCount }))),
                react_1.default.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsProperty, null,
                    react_1.default.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsLabel, null, catalog_messages_1.Messages.UsedByFlows()),
                    react_1.default.createElement(ColumnAndFieldDetailsStyles_1.ColumnFieldsWrapper, { style: { height: (0, LinksDisplayGrid_1.getRowHeight)(flowsCount, ColumnAndFieldDetailsStyles_1.columnFieldsWrapperMaxRows) } },
                        react_1.default.createElement(ColumnFlowsQueryGrid_1.ColumnFlowsQueryGrid, { columnId: props.columnId, rowCount: flowsCount })))))));
}
function ColumnDetailsDialogQueryWrapper(_a) {
    var { columnId, tableVizportalId: tableVizportalId } = _a, props = tslib_1.__rest(_a, ["columnId", "tableVizportalId"]);
    const apiRequests = (0, catalog_core_1.useApiRequests)();
    const { customSensitivityLabelsEnabled } = (0, catalog_core_1.useFeatureFlags)();
    const [canSetDescriptionAndTags, setCanSetDescriptionAndTags] = react_1.default.useState(false);
    react_1.default.useEffect(() => {
        apiRequests
            .canUserSetColumnDescription({ tableVizportalId: tableVizportalId !== null && tableVizportalId !== void 0 ? tableVizportalId : '' })
            .then(r => setCanSetDescriptionAndTags(r))
            .catch(() => {
            return;
        });
    }, [apiRequests, tableVizportalId]);
    return (react_1.default.createElement(components_1.Query, { query: catalog_queries_1.ColumnDetailsDocument, variables: { columnId: columnId, customSensitivityLabelsEnabled } }, result => (react_1.default.createElement(renderQueryResult_1.RenderQueryResult, { result: result, renderers: {
            renderData: ({ columns }) => {
                const column = columns === null || columns === void 0 ? void 0 : columns[0];
                if (!column) {
                    return null;
                }
                return (react_1.default.createElement(ColumnDetailsDialog, { columnId: columnId, onClose: props.onClose, afterDescriptionAndTagsChange: props.afterDescriptionAndTagsChange, column: column, canSetDescriptionAndTags: canSetDescriptionAndTags, detailsAction: props.detailsAction }));
            },
        } }))));
}
exports.ColumnDetailsDialogQueryWrapper = ColumnDetailsDialogQueryWrapper;
function extractTableLuid(column) {
    if (column.table && column.table.__typename === 'DatabaseTable') {
        return column.table.luid;
    }
    return null;
}
//# sourceMappingURL=ColumnDetailsDialog.js.map